import React from 'react';
import { Link } from "react-router-dom";

function Selection(){

   
      

    return (
       
        <>
          <div class="row">
            <div class="col-sm-6">
          <div className="card" style={{width: "18rem;"}}>
  <div className="card-body">
    <h5 className="card-title">Battery</h5>
    <Link to="/dashboard!2" className="">
                    <p className="card-text">Click Here</p>{" "}
                  </Link>
   
   
  </div>
</div></div>




<div class="col-sm-6">
          <div className="card" style={{width: "18rem;"}}>
  <div className="card-body">
    <h5 className="card-title">Wiki</h5>
    <Link to="/dashboard" className="">
                    <p className="card-text">Click Here</p>{" "}
                  </Link>
    
  </div>
</div></div>
          </div>
        </>
    )
}

export default Selection;